<template>
  <div class="col-12">
    <ul class="list-group">
      <li class="list-group-item">
        <div class="row">
          <div class="col-10">
            <h4>{{ $t("Report") }}</h4>
          </div>
          <div class="col-2">
            <h4>{{ $t("Run") }}</h4>
          </div>
        </div>
      </li>
      <li class="list-group-item" v-for="report in reportsData">
        <div class="row">
          <div class="col-10">
            {{ report.name }}
          </div>
          <div class="col-2">
            <router-link :to="'/report/' + report.uid">{{ $t("Details") }}</router-link>
          </div>
        </div>
      </li>
    </ul>

  </div>
</template>

<script>
  import APIHelper from "../mixins/APIHelper";
  export default {
    name: "reports",
    data: function () {
      return {
        reportsData: []
      }
    },
    created() {
      let vm = this;
      APIHelper.getResource("/api/report").then(function (data) {
        vm.reportsData = data;
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Reports.vue